import * as yup from "yup";

export const materialPlaningSchemaNew = yup.object().shape({
  clientName: yup.string().required("Client project is required"),
  bay_size: yup.string().required("length is required"),
  span_size: yup.string().required("width is required"),
  hydrponicType: yup.string().required("hydroponic type is required"),
  a_FramePercent: "",
  flatBedPercent: "",
  growBagPercent: "",
  growBagPercent: "",
  dutchBucketPercent: "",
});
